<form *ngFor="let form of formulario?.controls; index as i" class="forms" [formGroup]="form">
  <div class="input-multi">
    <div class="input-multi-container">
      <div class="removable-container">
        <label style="width: 20%;font-size: 1.2rem;float: left;margin-top: 9px;font-weight: 100;">Instituição</label>
        <div style="width: 78%;float: right;">
          <input
              class="form-control"
              type="text"
              placeholder="Nome da instituição"
              name="localCredito"
              formControlName="localCredito"
              maxlength="40"
              appShowErrorMessages>
          <input
              class="form-control"
              type="text"
              placeholder="Valor da parcela mensal (R$)"
              name="valorParcela"
              formControlName="valorParcela"
              [maxLength]="15"
              [minLength]="1"
              appOnlyDigitsLengthValidator
              appShowErrorMessages
              mask-money
              inputmode="numeric"
              [prefix]="'R$'"
              appOnlyNumberRestrictive>
          <input
              class="form-control"
              type="text"
              placeholder="Número de parcelas que faltam"
              name="quantidadeParcelasPendentes"
              maxlength="3"
              formControlName="quantidadeParcelasPendentes"
              inputmode="numeric"
              appShowErrorMessages
              appOnlyNumberRestrictive>
        </div>
        <p class="remove-item-btn" (click)="remove(i)" *ngIf="i > 0"><em class="fa fa-trash"></em></p>
      </div>
    </div>
  </div>
</form>
<div class="importante-info">
  Informar os 2 mais importantes.
</div>
<div class="add-dado" (click)="add()" [ngClass]="{ 'disable-add': formulario?.controls.length > 1 }">
  <p><em class="fa fa-plus"></em> Adicionar instituição</p>
</div>

